// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gu46W{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;overflow:hidden}.qM2a9{position:absolute;top:0;left:0;right:0;height:50%;pointer-events:none;z-index:0}.BhBlb{width:100%;height:100%}.CpmKU{align-items:center;gap:8px;text-align:center;width:100%;z-index:1}.yRVKF{color:#282863 !important;width:100%}.bSQo0{z-index:1;display:flex;justify-content:center}.YrCeZ{padding:12px 48px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `gu46W`,
	"confettiArea": `qM2a9`,
	"confettiLottie": `BhBlb`,
	"textContent": `CpmKU`,
	"description": `yRVKF`,
	"ctaWrapper": `bSQo0`,
	"ctaButton": `YrCeZ`
};
export default ___CSS_LOADER_EXPORT___;
